import styled from 'styled-components';

export const Wrapper = styled.div`
  //display: flex;
  align-items: center;
  //justify-content: flex-end;

  display: inline-flex;
  grid-template-columns: 1fr ;

  margin-right: 1.5rem;

  > .MuiFormControl-root:not(:first-child) {
    margin-left: 1rem;
  }
`;
